import { render } from "./navFooter.vue?vue&type=template&id=5142bf23&scoped=true"
import script from "./navFooter.vue?vue&type=script&lang=js"
export * from "./navFooter.vue?vue&type=script&lang=js"

import "./navFooter.vue?vue&type=style&index=0&id=5142bf23&lang=scss&scoped=true"

import exportComponent from "D:\\Word\\mingyou\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5142bf23"]])

export default __exports__